import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CallbackRequest, LicenseData } from "app/models/admin.model";
import { ResultResponse } from "app/models/common.model";
import { Product, ProductDetails } from "app/models/products.model";
import { ApiResponse } from "app/utilities/api-data.utilities";
import { map, Observable } from "rxjs";

@Injectable()
export class AdminService {

    adminUrl = "/admin";

    constructor(
        private httpClient: HttpClient,
      ) {}

    getManageLicensesIntroMessage(): Observable<string> {
      const url = this.adminUrl + '/license/intro-message';
      return this.httpClient.get<string>(url);
    }
    
    getManageLicensesProducts(): Observable<string[]> {
      const url = this.adminUrl + '/products';
      return this.httpClient.get<string[]>(url);
    }

    getManageLicensesData(productId: string): Observable<LicenseData[]> {
      const url = this.adminUrl + '/license-data';
      return this.httpClient.get<LicenseData[]>(url);
    }

    updateLicenseData(request: Partial<LicenseData>, product: string): Observable<ResultResponse> {
      const url = this.adminUrl + '/license-data/update';
      return this.httpClient.put<ResultResponse>(url, request);
    }

    addLicenseData(data: LicenseData): Observable<ResultResponse> {      
      const request = { "FirstName" : data.firstName,
                        "LastName": data.lastName,
                        "Email" : data.email,
                        "PartcipantType" : data.accessType,
                        "PurchaserCustomerNumber" : data.customerNumber,
                        "AgreementId" : data.agreementId
                      }
      return this.httpClient.post<ResultResponse>('ocmapi/addParticipant', request);
    }

    deleteLicenseData(data: LicenseData[], ids: number[]): Observable<ResultResponse> {      
      const customers: string[] = data.map(element => element.customerNumber);
      const request = {
        "AgreementId": data[0].agreementId,
        "CustomerNumber": customers,
        "Ids": ids
      }
      return this.httpClient.post<ResultResponse>('ocmapi/removeParticipant', request);
    }

    getManageAdminsIntroMessage(): Observable<string> {
      const url = this.adminUrl + '/admins/intro-message';
      return this.httpClient.get<string>(url);
    }

    getManageAdminData(productId: string): Observable<LicenseData[]> {
      const url = this.adminUrl + '/admin-data';
      return this.httpClient.get<LicenseData[]>(url);
    }

    updateAdminData(request: Partial<LicenseData>, product: string): Observable<ResultResponse> {
      const url = this.adminUrl + '/admin-data/update';
      return this.httpClient.put<ResultResponse>(url, request);
    }

    addAdminData(request: Partial<LicenseData>, product: string): Observable<ResultResponse> {
      const url = this.adminUrl + '/admin-data/add';
      return this.httpClient.put<ResultResponse>(url, request);
    }

    deleteAdminData(request: Partial<LicenseData>, product: string): Observable<ResultResponse> {
      const url = this.adminUrl + '/admin-data/delete';
      return this.httpClient.put<ResultResponse>(url, request);
    }

    participantCallback(request: CallbackRequest): Observable<any> {
     // return this.httpClient.post<any>(`${this.apiUrl}/participantCallback`, request);
      return this.httpClient.post<any>('ocmapi/participantCallback', request);
    } 
    
}